const FLOATING_UI_PORTAL_ATTR = 'data-floating-ui-portal';

function hasFloatingUiOwnerInContainer(elementId: string, container: HTMLElement): boolean {
  const escapedId = CSS.escape(elementId);
  return (
    container.querySelector(`[aria-controls="${escapedId}"]`) !== null ||
    container.querySelector(`[aria-describedby="${escapedId}"]`) !== null ||
    container.querySelector(`[aria-labelledby="${escapedId}"]`) !== null
  );
}

/**
 * Returns true when `target` is inside a floating-ui flyout (including portaled
 * content) whose trigger/reference element lives inside `container`.
 */
export function isFloatingUiTargetOwnedByContainer(
  target: EventTarget | null,
  container: HTMLElement
): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  let node: Element | null = target;
  while (node) {
    if (
      node instanceof HTMLElement &&
      node.id &&
      hasFloatingUiOwnerInContainer(node.id, container)
    ) {
      return true;
    }

    if (node.hasAttribute(FLOATING_UI_PORTAL_ATTR)) {
      break;
    }

    node = node.parentElement;
  }

  return false;
}

/** True when an open floating-ui flyout is anchored inside `container`. */
export function hasOpenFloatingUiInsideContainer(container: HTMLElement): boolean {
  return container.querySelector('[aria-expanded="true"]') !== null;
}
